import { transform } from './mapper.js'

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Practitioner'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'active' ],
    form: [ 'active' ]
  },
  {
    fhir: [ 'member', 'id' ],
    form: [ 'member', 'id' ],
    to_fhir: x => x,
    to_form: x => x
  },
  {
    fhir: [ 'name', 0, 'family', 0 ],
    form: [ 'lastName' ]
  },
  {
    fhir: [ 'name', 0, 'given', 0 ],
    form: [ 'firstName' ]
  },
  {
    fhir: [ 'name', 0, 'suffix', 0 ],
    form: [ 'honorifics' ]
  },
  {
    fhir: [ 'telecom', { system: 'phone' }, 'value' ],
    form: [ 'phone' ],
    to_fhir: x => x.replace(/\./g, '-'),
    to_form: x => x.replace(/-/g, '.')
  },
  {
    fhir: [ 'telecom', { system: 'email' }, 'value' ],
    form: [ 'email' ]
  },
  {
    fhir: [ '_careTeamRole' ],
    form: [ 'role' ]
  },
  {
    fhir: [ '_alertLevel' ],
    form: [ 'alertLevel' ]
  }
]

export const mapTeamMember = (patientId, form) =>
  transform(form, mapping, [ 'form', 'fhir' ])

export const unmapTeamMember = data =>
  transform(data, mapping, [ 'fhir', 'form' ])
